import React from "react";
import CustomIcon from "../../assets/images/Custom Icon (1).svg";
import Pattern from "../../assets/images/Pattern.svg";
import mail from "../../assets/images/mail-line.svg";
import mailerror from "../../assets/images/mail-line (1).svg";
import check from "../../assets/images/check-line.svg";
import error from "../../assets/images/error-warning-fill.svg";
import Group from "../../assets/images/Header (1).svg";
import CustomInput from "../../components/common/InputField/InputField";
import globe from "../../assets/icons/global.svg";
import pic from "../../assets/icons/2024.svg";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./ResetPassword.css";
import apiService from "../../services/apiService";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const [language, setLanguage] = React.useState("en");

  let isRtl = language === "ar";
  const handleLanguageChange = (e) => {
    const selectedLanguage = e.target.value;
    setLanguage(selectedLanguage);
  };

  const navigate = useNavigate();

  const handleRegisterClick = () => {
    // Navigate to the registration page (change the path to your desired route)
    navigate("/");
  };

  const formik = useFormik({
    initialValues: {
      email: "", // Initial value for the email field
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required(
          "Oops! We couldn’t find that Email, Double-check and try again!"
        ),
    }),
    onSubmit: async (values) => {
      try {
        const response = await apiService.post("sendResetLink", values);
        toast.success(response.message, { toastId: "6" });
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } catch (e) {
        console.log(e);
        toast.error(e.message, { toastId: "7" });
      }
    },
  });

  return (
    <div>
      <section
        class="bg-[#F6F8FA] "
        style={{ backgroundImage: `url(${Pattern}) h-[526px]` }}
      >
        <div className="p-12">
          <img src={Group} alt="logo" />
        </div>

        <div
          class="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0"
          dir={isRtl ? "rtl" : "ltr"}
        >
          <div class="w-full h-[550px]  p-6 bg-white rounded-[24px] shadow  md:mt-0 sm:max-w-md   sm:p-8">
            <div className="flex flex-col items-center justify-center pb-6">
              <div style={{ paddingBottom: "15px" }}>
                <img src={CustomIcon} alt="logo" className="mb-15" />
              </div>
              <h2 class="title-h5  mb-1 text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">
                Reset Password
              </h2>
              <p>Enter your email to reset your password.</p>
            </div>
            <div className="pb-0">
              <hr />
            </div>
            <form
              class="mt-4 space-y-4 lg:mt-5 md:space-y-5"
              onSubmit={formik.handleSubmit}
            >
              <div>
                <CustomInput
                  SecondIcon={
                    !(formik.touched.email && formik.errors.email) ? (
                      <img src={check} alt="logo" />
                    ) : null
                  }
                  Secondposition={"right-4"}
                  icon={
                    !(formik.touched.email && formik.errors.email) ? (
                      <img src={mail} alt="logo" />
                    ) : (
                      <img src={mailerror} alt="logo" />
                    )
                  }
                  position={"left-4"}
                  labelClass={`label-class`}
                  isRequiredClass="text-[#2D9F75]"
                  isRequired={true}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name={"email"}
                  label="Email Address"
                  className={`border  ${!(formik.touched.email && formik.errors.email)
                      ? "border-gray-300"
                      : "border-[red]"
                    } text-gray-800 bg-white focus:bg-transparent rounded-[12px] focus:outline-none px-5 py-3.5`}
                  height="h-[40px]"
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="flex">
                    <div className="mt-2 pr-2">
                      <img src={error} alt="logo" />{" "}
                    </div>
                    <div className="text-red-500 text-sm mt-1">
                      {formik.errors.email}
                    </div>
                  </div>
                ) : null}
              </div>

              <button
                type="submit"
                class="w-full text-[white] bg-[#007A63] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center  :bg-primary-700 :ring-primary-800"
              >
                Reset passwod
              </button>
              <div className="flex flex-col items-center justify-center pt-4">
                <div className="paragraph-small mb-1">
                  Don’t have access anymore?
                </div>
                <div className="text-underline-right"> Try another method</div>
              </div>
            </form>
          </div>

          <div className="mt-14">
            <span className="paragraph-small"> Changed your mind? </span>
            <span
              className="text-styled-underline course-pointer"
              style={{ cursor: "pointer" }}
              onClick={() => handleRegisterClick()}
            >
              {" "}
              Go Back{" "}
            </span>
          </div>
        </div>
        <div className="flex items-center justify-between p-12">
          <div
            style={{ fontFamily: "inter" }}
            className="font-[400] text-[#525866] text-sm"
          >
            <img src={pic} alt="logo" />
          </div>
          <form class=" flex item-center">
            <img src={globe} alt="logo" />
            <select
              id="countries_disabled"
              value={language}
              onChange={handleLanguageChange}
              style={{ fontFamily: "inter" }}
              className="custom-dropdown bg-[#F6F8FA] border-[#F6F8FA] font-[400] text-[#525866] text-sm rounded-lg focus:ring-[white] focus:border-[white] block w-[76px] p-2.5 "
            >
              <option value="en">ENG</option>
              <option value="ar">AR</option>
            </select>
          </form>
        </div>
      </section>
    </div>
  );
};

export default ResetPassword;
